import { db } from "helpers/firebase";

export const getRoleRef = (uid) => {
  const ref = db.doc(`/roles/${uid}`);
  return ref;
}